import firebase from 'firebase/compat/app'
import 'firebase/compat/firestore'

export const logBusinessEvent = async (businessId: string, message: string) =>
  firebase.firestore().collection('business').doc(businessId).collection('logs').add({
    time: firebase.firestore.FieldValue.serverTimestamp(),
    message,
  })
